import {
  SAVE_ACCOUNT,
  SAVE_ACCOUNT_PROFILE,
  SAVE_ACCOUNT_BRANDING,
  SAVE_ACCOUNT_SCHEDULE_SETTINGS,
  SAVE_ACCOUNT_REGIONAL_SETTINGS,
  SAVE_ACCOUNT_COMMUNICATION_SETTINGS,
  SAVE_ACCOUNT_REQUEST_SETTINGS,
  SAVE_ACCOUNT_QUOTE_SETTINGS,
  SAVE_ACCOUNT_JOB_SETTINGS,
  SAVE_ACCOUNT_JOB_TYPES,
  SAVE_ACCOUNT_JOB_STATUSES,
  SAVE_ACCOUNT_INVOICE_SETTINGS,
  SAVE_ACCOUNT_LICENSE_SETTINGS,
  SAVE_ACCOUNT_DISPLAY_CONFIG_SETTINGS,
} from 'redux/constants/Account';

export function saveAccount(account) {
  return {
    type: SAVE_ACCOUNT,
    payload: account
  };
}

export function saveAccountProfile(accountProfile) {
  return {
    type: SAVE_ACCOUNT_PROFILE,
    payload: accountProfile
  };
}

export function saveAccountBranding(accountBranding) {
  return {
    type: SAVE_ACCOUNT_BRANDING,
    payload: accountBranding
  };
}

export function saveAccountScheduleSettings(accountScheduleSettings) {
  return {
    type: SAVE_ACCOUNT_SCHEDULE_SETTINGS,
    payload: accountScheduleSettings
  };
}
export function saveAccountRegionalSettings(accountRegionalSettings) {
  return {
    type: SAVE_ACCOUNT_REGIONAL_SETTINGS,
    payload: accountRegionalSettings
  };
}
export function saveAccountCommunicationSettings(accountCommunicationSettings) {
  return {
    type: SAVE_ACCOUNT_COMMUNICATION_SETTINGS,
    payload: accountCommunicationSettings
  };
}
export function saveAccountRequestSettings(accountRequestSettings) {
  return {
    type: SAVE_ACCOUNT_REQUEST_SETTINGS,
    payload: accountRequestSettings
  };
}
export function saveAccountQuoteSettings(accountQuoteSettings) {
  return {
    type: SAVE_ACCOUNT_QUOTE_SETTINGS,
    payload: accountQuoteSettings
  };
}
export function saveAccountJobSettings(accountJobSettings) {
  return {
    type: SAVE_ACCOUNT_JOB_SETTINGS,
    payload: accountJobSettings
  };
}
export function saveAccountJobTpes(accountJobTypes) {
  return {
    type: SAVE_ACCOUNT_JOB_TYPES,
    payload: accountJobTypes
  };
}
export function saveAccountJobStatuses(accountJobStatuses) {
  return {
    type: SAVE_ACCOUNT_JOB_STATUSES,
    payload: accountJobStatuses
  };
}
export function saveAccountInvoiceSettings(accountInvoiceSettings) {
  return {
    type: SAVE_ACCOUNT_INVOICE_SETTINGS,
    payload: accountInvoiceSettings
  };
}
export function saveAccountLicenseSettings(accountLicenseSettings) {
  return {
    type: SAVE_ACCOUNT_LICENSE_SETTINGS,
    payload: accountLicenseSettings
  };
} 
export function saveAccountDisplayConfigSettings(accountDisplayConfigSettings) {
  return {
    type: SAVE_ACCOUNT_DISPLAY_CONFIG_SETTINGS,
    payload: accountDisplayConfigSettings
  };
} 
 